/**
 * FlashMessageDefaults.js
 *
 * Shared constants and defaults for flash message system.
 * Used by FlashMessageManager across the application.
 */

// Default configuration for flash messages
const DEFAULT_FLASH_OPTIONS = Object.freeze({
  position: 'top-right',
  duration: 5000,
  errorDuration: 8000,
  showIcon: true,
  showCloseButton: true,
  stackMessages: true
});


// Flash message icons
const FLASH_ICONS = {
  success: '✓',
  error: '✕',
  warning: '⚠',
  info: 'ℹ'
};

// Flash message related constants
const FLASH_CONSTANTS = {
  SELECTORS: {
    FLASH_CONTAINER: '.flash-messages-container',
    FLASH_MESSAGE: '.flash-message'
  },
  CLASSES: {
    FLASH_MESSAGE: 'flash-message',
    FLASH_SHOW: 'flash-message-show',
    FLASH_HIDE: 'flash-message-hide'
  },
  TIMING: {
    FLASH_HIDE_DELAY: 300
  }
};

export {
  DEFAULT_FLASH_OPTIONS,
  FLASH_ICONS,
  FLASH_CONSTANTS
};
